import styled from 'styled-components';

export const ContainerMain = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100vh;
  width: 100vw;
  background-color: rgba(100, 100, 100, 0.4);
`;

export const GifLoading = styled.img`
  width: 20vw;
  height: 20vw;
`;
